import { StatelessComponent } from 'react'
import * as styles from 'styles/unorganized/ProviderBadge.css'
import { getProviderLogoPath } from 'helpers/linkageHelpers'
import { BaseProvider } from 'interfaces/linkage'

export type ProviderBadgeProps = BaseProvider & {
  onClick?: () => void
}

const ProviderBadge: StatelessComponent<ProviderBadgeProps> = (props) => {
  const { logo, name, onClick } = props
  const logoPath = getProviderLogoPath(name)

  return (
    <button
      className={ styles.providerBadge }
      title={ name }
      onClick={ onClick }
    >
      <div
        className={ styles.logo }
        style={{ backgroundImage: `url(${ logoPath || logo })` }}
      />
    </button>
  )
}

export default ProviderBadge
